<template>
  <DsMediaLayout
    class="ds-media-text-component"
    :orientation="mediaPosition"
    :media-columns-width="mediaColumnsWidth"
    :content-columns-width="contentColumnsWidth"
    :is-sm-only-column-reverse="true"
  >
    <template #media>
      <template v-if="video">
        <DsVideoElement
          v-if="videoAutoplay"
          v-bind="video"
          :screen="screen"
          data-j-video-autoplay
        />
        <DsVideoPlayer
          v-else
          v-bind="video"
          :screen="screen"
          :aria-label-play="labels.play"
          :aria-label-close="labels.close"
          data-j-video
        />
      </template>
      <DsImageElement
        v-else-if="image"
        :image="image"
        :screen="screen"
        data-j-image
      />
    </template>
    <template #content>
      <div
        class="landing-media-text__container ds-margin-top-48 ds-md-margin-top-0"
        :class="{ 'landing-media-text__container--title-only': !$slots.default }"
      >
        <div
          class="landing-media-text__wrapper"
          :class="{ 'landing-media-text__wrapper--title-only': !$slots.default }"
        >
          <h2
            v-if="title"
            class="ds-heading"
          >
            {{ title }}
          </h2>
          <div v-if="$slots.default">
            <slot />
          </div>
          <div v-if="link">
            <DsLink
              :content="link.title"
              :url="link.url"
              :nuxt="link.nuxt"
              :open-in-new-window="link.openInNewWindow"
              :icon-right="{ category: 'arrows', name: 'chevron-right-small' }"
            />
          </div>
        </div>
      </div>
    </template>
  </DsMediaLayout>
</template>

<script setup>
import { DsImageElement, DsMediaLayout, DsVideoElement, DsVideoPlayer, DsLink, validatorOrientation } from 'awds'
import { positions as PositionType } from '../../constants/positions'
const { labels } = useGlobalData()

const contentColumnsWidth = ref({ small: 12, medium: 6, large: 5 })
const mediaColumnsWidth = ref({ small: 12, medium: 6, large: 6 })

defineProps({
  mediaPosition: {
    type: String,
    default: PositionType.right,
    validator: (str) => validatorOrientation(str)
  },
  image: {
    type: Object,
    default: null
  },
  video: {
    type: Object,
    default: null
  },
  videoAutoplay: {
    type: Boolean,
    default: false
  },
  title: {
    type: String,
    default: ''
  },
  description: {
    type: String,
    default: ''
  },
  link: {
    type: Object,
    default: null
  },
  screen: {
    type: String,
    required: true
  }
})
</script>

<style lang="scss" scoped>
.landing-media-text {
  &__container {
    width: 100%;
    container-type: inline-size;
    container-name: landing-block-media;
    display: flex;
    &--title-only {
      justify-content: flex-start;
      margin: 0 auto;
    }
  }

  &__wrapper {
    display: grid;
    gap: 12px;
    grid-template-columns: 1fr;
    h2 {
      text-wrap: balance;
    }
  }
}

@container landing-block-media (min-width: 700px) {
  .landing-media-text__wrapper {
    grid-template-columns: 1fr 1fr;
    gap: 48px;
    &--title-only {
      grid-template-columns: 1fr;
    }
  }
}
</style>
